import { Pipe, type PipeTransform } from '@angular/core';
import { type DeviceData, type NormalizedDeviceData } from '@devices';

@Pipe({
  name: 'avsDeviceAttribute',
})
export class DeviceAttributePipe implements PipeTransform {
  transform(device: NormalizedDeviceData | DeviceData, attributeName: string, returnValue = false, placeholder = '') {
    const attributes = device.additionalAttributes || [];
    const foundAttribute = attributes.find(attribute => attribute.name === attributeName);
    const candidate = device[attributeName as keyof (NormalizedDeviceData | DeviceData)];
    const deviceValue = typeof candidate === 'string' ? candidate : null;

    if (returnValue) {
      return foundAttribute?.value || placeholder;
    }

    return foundAttribute?.friendlyName || deviceValue || placeholder;
  }
}
